module.exports = __webpack_public_path__ + "static/media/profile.e315a396.png";